import { Alert, Button, Grid, Stack, Typography } from "@mui/material";
import ReactPhoneInput from 'react-phone-input-material-ui';

import WushTextField from "../../../form/WushTextField";
import { useForm } from "react-hook-form";
import * as yup from 'yup';
import useCheckoutStore from "../../../../stores/public/useCheckoutStore";
import update from "../../../../api/public/storefronts/customers/update";
import updateOrderApi from "../../../../api/public/storefronts/orders/update";
import useStorefrontStore from "../../../../stores/public/useStorefrontStore";
import useYupValidationResolver from "../../../../services/useYupValidationResolver";
import create from "../../../../api/public/storefronts/customers/create";
import WushCard from "../../../layout/WushCard";
import { useEffect, useState } from "react";

const validationSchema = yup.object({
  first_name: yup.string().required("Required"),
  last_name: yup.string().required("Required"),
  email: yup.string().email("Invalid email").required("Required"),
  phone: yup.string().min(11, "Invalid phone number").required("Required")
});

export default function CustomerInformation() {
  const { organization } = useStorefrontStore();
  const { customer, setCustomer, order, setOrder } = useCheckoutStore();

  const [editing, setEditing] = useState(customer?.id ? false : true);


  const resolver = useYupValidationResolver(validationSchema);

  const { register, handleSubmit, setValue, formState } = useForm({
    resolver: resolver,
    defaultValues: customer,
    reValidateMode: 'onSubmit'
  });

  const onSubmit = (values) => {
    if(customer?.id) {
      update(organization.id, customer.id, values, (response) => {
        updateOrderApi(organization.id, order.id, {
          customer_id: response.id
        }, (response) => {
          setOrder(response);
        });
        setCustomer(response);
      });
    } else {
      create(organization.id, values, (response) => {
        updateOrderApi(organization.id, order.id, {
          customer_id: response.id
        }, (response) => {
          setOrder(response);
        });
        setCustomer(response);
      });
    }

    setEditing(false);
  };

  useEffect(() => {
    updateOrderApi(organization.id, order.id, { checkout_status: 'customer_information' });
  }, []);

  useEffect(() => {
    if(customer?.id) {
      updateOrderApi(organization.id, order.id, {
        customer_id: customer.id
      }, (response) => {
        setOrder(response);
      });
    }
  }, []);

  console.log(formState);

  return (
    <Stack>
      <WushCard bgcolor={"#ffffff"}>
        <Stack p={2}>
          {
            editing ?
            <form onSubmit={handleSubmit(onSubmit)}>
              <Stack gap={1} mb={1}>
                <Stack mb={1}>
                  <Typography variant="h4">Customer Information</Typography>
                </Stack>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Stack>
                      <WushTextField formRegistration={register('first_name')} formState={formState} label="First Name" defaultValue={customer?.first_name} />
                    </Stack>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Stack>
                      <WushTextField formRegistration={register('last_name')} formState={formState} label="Last Name" defaultValue={customer?.last_name} />
                    </Stack>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Stack spacing={2}>
                      <ReactPhoneInput
                        onChange={(phone) => setValue('phone', phone) }
                        country={'us'}
                        onlyCountries={['us']}
                        countryCodeEditable={false}
                        component={WushTextField}
                        withCountryCallingCode={true}
                        value={customer?.phone}
                        inputProps={{
                          formState: formState,
                        }}
                      />
                      {formState.errors?.phone && <Alert severity="error">Invalid phone number</Alert>}
                    </Stack>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Stack>
                      <WushTextField formRegistration={register('email')} formState={formState} label="Email" defaultValue={customer?.email} />
                    </Stack>
                  </Grid>
                </Grid>
              </Stack>
              <Stack direction="row" width="100%" justifyContent="right">
                <Button width="500px" size="large" variant="contained" onClick={handleSubmit(onSubmit)}>Continue</Button>
              </Stack>
            </form> :
            <Stack>
              <Stack mb={1}>
                <Typography variant="h4" sx={{ my: "auto" }}>
                  {customer?.full_name}
                </Typography>
                <Typography variant="h5" sx={{ my: "auto" }}>
                  {customer?.email}
                </Typography>
              </Stack>
              <Stack direction="row">
                <Button variant="outlined" onClick={() => setEditing(true)}>Edit</Button>
              </Stack>
            </Stack>
          }

        </Stack>
      </WushCard>
    </Stack>
  );
}